import LifecareStudioTableRow, {
  LIFECARE_TABLE_COLUMN_LABELS,
} from './LifecareStudioTableRow';
import {
  inlineButtonClasses,
  tableBodyCellClasses,
  tableClasses,
  tableHeadCellClasses,
  tableWrapperClasses,
  totalsCellClasses,
} from './lifecareStudioClasses';
import { formatCurrency } from '../../utils/lifecarePlanUtils';
import useLifecareStudioTable from '../../hooks/useLifecareStudioTable';

const subtotalLabelClasses = 'text-right text-sm font-bold uppercase tracking-wider text-subtle py-2 pr-3';

const LifecareStudioTable = ({
  rows,
  subtotal,
  moveTargets,
  onFieldChange,
  onAddRow,
  onRemoveRow,
  onMoveRow,
}) => {
  const { safeRows, hasRows } = useLifecareStudioTable({ rows });
  return (
    <div className={tableWrapperClasses}>
      <table className={tableClasses}>
        <thead>
          <tr>
            {LIFECARE_TABLE_COLUMN_LABELS.map((label, index) => (
              <th key={index} className={tableHeadCellClasses}>
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!hasRows ? (
            <tr>
              <td
                colSpan={LIFECARE_TABLE_COLUMN_LABELS.length}
                className={`${tableBodyCellClasses} text-center text-subtle`}
              >
                No rows yet. Use "Add row" below to add one.
              </td>
            </tr>
          ) : (
            safeRows.map((row, rowIndex) => (
              <LifecareStudioTableRow
                key={rowIndex}
                row={row}
                moveTargets={moveTargets}
                onFieldChange={({ field, value }) =>
                  onFieldChange({ rowIndex, field, value })
                }
                onRemove={() => onRemoveRow({ rowIndex })}
                onMoveRow={({ targetSubsectionIndex }) =>
                  onMoveRow({ rowIndex, targetSubsectionIndex })
                }
              />
            ))
          )}
          <tr>
            <td
              colSpan={LIFECARE_TABLE_COLUMN_LABELS.length - 2}
              className={subtotalLabelClasses}
            >
              Subsection subtotal
            </td>
            <td className={`${tableBodyCellClasses} ${totalsCellClasses}`}>
              {formatCurrency(subtotal)}
            </td>
            <td className={tableBodyCellClasses} />
          </tr>
        </tbody>
      </table>
      <div className="mt-3">
        <button type="button" className={inlineButtonClasses} onClick={onAddRow}>
          <i className="fa fa-plus" />
          <span>Add row</span>
        </button>
      </div>
    </div>
  );
};

export default LifecareStudioTable;
